import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import RoadsideAssistancesFields from './roadsideAssistancesFields';
import axiosClient from '../../../../config/axios.js';

function EditRoadsideAssistance() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { Formik } = formik;

    const [initialValues, setInitialValues] = useState({
        roadsideAssistance_name: '',
        roadsideAssistanceContacts: [],
    });

    useEffect(() => {
        axiosClient.get(`/roadsideAssistance/${id}`)
            .then(response => {
                console.log("API Response:", response.data); // Para depuración

                const { roadsideAssistance_name, RoadsideAssistanceContacts } = response.data;

                setInitialValues({
                    roadsideAssistance_name,
                    roadsideAssistanceContacts: RoadsideAssistanceContacts || [], // Asegura que siempre sea un array
                });
            })
            .catch(error => {
                console.error('Error fetching roadside assistance data:', error);
            });
    }, [id]);

    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Configuración</li>
                        <li className="breadcrumb-item"><Link to="/catalogs/roadsideAssistances">Asistencias viales</Link></li>
                        <li className="breadcrumb-item active">Edición de Asistencia vial</li>
                    </ol>
                    <h1 className="page-header mb-0">Edición de Asistencia vial</h1>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Edición de Asistencia vial</PanelHeader>
                        <PanelBody>
                            <Formik
                                enableReinitialize
                                validationSchema={yup.object().shape({
                                    roadsideAssistance_name: yup.string().required("Ingrese el nombre de la Asistencia vial"),
                                    roadsideAssistanceContacts: yup.array().of(
                                        yup.object().shape({
                                            name: yup.string().required('Favor de escribir el nombre'),
                                            position: yup.string().required('Favor de escribir el puesto'),
                                            phone: yup.string().required('Favor de escribir el número telefónico de contacto'),
                                        })
                                    ),
                                })}
                                onSubmit={(values, { setSubmitting }) => {
                                    setSubmitting(false);

                                    // Renombrar la propiedad justo antes de enviarla
                                    const formattedValues = {
                                        roadsideAssistance_name: values.roadsideAssistance_name,
                                        RoadsideAssistanceContacts: values.roadsideAssistanceContacts, // Cambio de nombre
                                    };

                                    console.log("Payload enviado al backend:", formattedValues); // Depuración

                                    axiosClient.put(`/roadsideAssistance/${id}`, formattedValues)
                                        .then(response => {
                                            Swal.fire({
                                                title: 'Cambios guardados.',
                                                text: 'La Asistencia vial se ha actualizado exitosamente',
                                                icon: 'success',
                                                confirmButtonText: 'Cerrar',
                                            });
                                            navigate('/catalogs/RoadsideAssistances');
                                        })
                                        .catch(err => {
                                            Swal.fire({
                                                title: 'Ups!',
                                                text: err.response?.data?.message || "Ocurrió un error inesperado",
                                                icon: 'error',
                                                confirmButtonText: 'Cerrar',
                                            });
                                        });
                                }}
                                initialValues={initialValues}
                            >
                                {({ handleSubmit, handleChange, handleBlur, values, touched, errors, setFieldValue, setFieldTouched }) => (
                                    <Form noValidate onSubmit={handleSubmit}>
                                        <RoadsideAssistancesFields
                                            handleSubmit={handleSubmit}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                        />

                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Button type="submit">Guardar cambios</Button>{' '}
                                                <Link to={'/catalogs/roadsideAssistances'} className="btn btn-info">Cancelar</Link>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>
                        </PanelBody>
                    </Panel>
                </div>
            </div>
        </div>
    );
}

export default EditRoadsideAssistance;
